import {
    MILITARY_VARIANT,
    STC_VARIANT,
    matrixRoot,
    openFormsSignatories,
} from "../_variants/index.js";
import {
    addFileToTester,
    addFormFourFile,
    addNote,
    addPanelLimitations,
    addSampleSignature,
    answerQuestion,
    deleteFile,
    downloadFile,
    downloadFile2,
    downloadTesterFile,
    hoaApproveNote,
    hodApproveNote,
    linkFormFourFile,
    reviewAnswer,
    updateAdditionalLimitations,
    updateAdditionalRoles,
    updateNote,
    updatePanel,
    updatePanelLimitations,
    updatePanelLimitations2,
    uploadFile,
    viewNote
} from "./actions";
import {
    addRecord,
    removeRecord,
    updateRecord
} from "./actions";

import HTMLTooltip from "./HTMLTooltip.vue";
import {
    files as _files
} from "../../standardAttachables";
import { buildLimitations } from "./utils";
import {
    get
} from "lodash";
import { loadSignatureImage } from "../../signatureImage.js";
import store from "../../../store";

// Resolve variant from meta.formMetadata.ParentType (same as grid)
const resolveVariant = (meta) => 
    meta?.formMetadata?.ParentType === "MilitarySignatoryMatrix" ? MILITARY_VARIANT : STC_VARIANT;

let files = {
    ..._files
}
let files2 = {
    ..._files
}

let testersFiles = {
    ..._files
}

files.headers = files.headers.filter(i => !i.headerName.includes("Date"))

files.actions = [{
    "label": "Upload File",
    "action": uploadFile
}];

files.rowActions = [{
    "label": "Download",
    "action": downloadFile
}, {
    "label": "Delete File",
    "class": "text-red",
    "action": deleteFile
}];

testersFiles.actions = [{
    "label": "Upload File",
    "action": addFileToTester
}];

testersFiles.rowActions = [{
    "label": "Download",
    "action": downloadTesterFile
}, {
    "label": "Delete File",
    "class": "text-red",
    "action": deleteFile
}];

files2.actions = [];

files2.rowActions = [{
    "label": "Download",
    "action": downloadFile2
}];

// Variant-specific security check: Military.Reviewer for military variant, Matrices.Reviewer for STC
const show = ({ store, pageItem, meta }) => {
    const variant = resolveVariant(meta);
    const isMilitary = variant.key === "military";
    const hasReviewerAccess = isMilitary
        ? store?.state?.user?.Security?.Military?.Reviewer === true
        : store?.state?.user?.Security?.Matrices?.Reviewer === true;
    return hasReviewerAccess || pageItem?.AccountID === store.getters.userID;
};

files.show = show;
files2.show = show;

export const panels = {
    "label": "Panels",
    "key": "Panels",
    "local": true,
    "paginationPageSize": 50,
    "headers": [{
        "headerName": "Panel",
        valueFormatter(params) {
            return store?.state["Matrices/SignatoryMatrix/Panels"]?.[params.data.ID]?.NamePretty || params.data.ID;
        }
    }, {
        "headerName": "Checker / Approver / CVE",
        "field": "Answer",
        "type": "cve"
    }, {
        "headerName": "Limitations",
        "field": "Limitations",
        "flex": 1,
        valueFormatter(params) {
            if (params.data.Answer === "None" || params.data.Answer === false) return "N/A";
            let limitations = Object.values(params.data.Limitations || []);
            return `${limitations.length} Limitation${limitations.length === 1 ? "" : "s"}`;
        },
        cellStyle(params) {
            return !params.data.Answer || (params.data.Answer === "None") ? {
                "color": "#ccc"
            } : null
        },
        tooltipComponent: HTMLTooltip,
        tooltipShowDelay: 0,
        tooltipValueGetter(params) {

            return params.data.Limitations ? `<p>${Object.values(params.data.Limitations || {}).map(i => i.Limitation).join("<br>")}</p> ` : "No Limitations";
        }
    }],
    // "actions": [{
    //     "label": "Update Panels",
    //     "action": updatePanels,
    //     show({ store }) { return [store?.state?.user?.Security?.Matrices?.Reviewer === true, "You cannot update panels"] }
    // }],
    "rowActions": [{
        "label": "Update Panel",
        "action": updatePanel,

        show({ store, meta }) {
            const viewingNew = store.state.sigMatrixViewingNew;
            const variant = resolveVariant(meta);
            const isMilitary = variant.key === "military";
            const isReviewer = isMilitary
                ? store?.state?.user?.Security?.Military?.Reviewer === true
                : store?.state?.user?.Security?.Matrices?.Reviewer === true;
            const errorMessage = !isReviewer ? "You must be a reviewer to update panels." : "To change panels, you must be viewing the latest changes of the matrix.";
            return [viewingNew && isReviewer, errorMessage];
        }
    }, {
        "label": "Add Limitation",
        "action": addPanelLimitations,
        "break": true,
        show({ store, meta }) {
            const viewingNew = store.state.sigMatrixViewingNew;
            const variant = resolveVariant(meta);
            const isMilitary = variant.key === "military";
            const isReviewer = isMilitary
                ? store?.state?.user?.Security?.Military?.Reviewer === true
                : store?.state?.user?.Security?.Matrices?.Reviewer === true;
            const errorMessage = !isReviewer ? "You must be a reviewer to update panels." : "To change panels, you must be viewing the latest changes of the matrix.";
            return [viewingNew && isReviewer, errorMessage];
        }
    }, {
        "label": "Update Limitations",
        "action": updatePanelLimitations,
        show({ store, meta }) {
            const viewingNew = store.state.sigMatrixViewingNew;
            const variant = resolveVariant(meta);
            const isMilitary = variant.key === "military";
            const isReviewer = isMilitary
                ? store?.state?.user?.Security?.Military?.Reviewer === true
                : store?.state?.user?.Security?.Matrices?.Reviewer === true;
            const errorMessage = !isReviewer ? "You must be a reviewer to update panels." : "To change panels, you must be viewing the latest changes of the matrix.";
            return [viewingNew && isReviewer, errorMessage];
        }
    }]
};

export const limitations = {
    "label": "Limitations",
    "field": true,
    "fields": [{
        "label": "All limitations",
        "class": "md:col-span-3",
        "grow": true,
        compute({ item }) {
            return buildLimitations(item, store)
        }
    }],
    "actions": [{
        "label": "Update Additional Limitations",
        "action": updateAdditionalLimitations,
        show({ store, meta }) {
            const variant = resolveVariant(meta);
            const isMilitary = variant.key === "military";
            const isReviewer = isMilitary
                ? store?.state?.user?.Security?.Military?.Reviewer === true
                : store?.state?.user?.Security?.Matrices?.Reviewer === true;
            return [isReviewer, "You cannot update additional Limitations"];
        }
    }],
    computedActions({ form, store, pageItem, router }) {

        let panels = Object.values(pageItem?.Panels || {}).filter(i => {
            return !!i.Limitations;
        }).map((i, index) => {
            return {
                "break": index === 0,
                "label": `Update - ${store.state["Matrices/SignatoryMatrix/Panels"]?.[i.ID]?.NamePretty || i.ID}`,
                "action": updatePanelLimitations2({ form, rowItem: i, pageItem }),
                "show": () => [router.currentRoute.value.params.showLatest === "true", "To change limitations, you must be viewing the latest changes of the matrix."]
            };
        });
        return panels;
    }
};

export const notes = {
    "label": "Notes",
    "key": "Notes",
    "local": true,
    "headers": [{
        "headerName": "Title",
        "field": "Title"
    }, {
        "headerName": "Note",
        "field": "Note",
        "type": "html"
    }, {
        "headerName": "Date",
        "field": "Date",
        "type": "date"
    }, {
        "headerName": "HoD Approval",
        "field": "HoDApproval",
        "type": "bool"
    }, {
        "headerName": "HoA Approval",
        "field": "HOAApproval",
        "type": "bool"
    }],
    "actions": [{
        "label": "Add Note",
        "action": addNote
    }],
    "rowActions": [{
        "label": "View Note",
        "action": viewNote
    }, {
        "label": "Update Note",
        "action": updateNote
    }, {
        "label": "HoD Approval",
        action: hodApproveNote,
        show({ rowItem }) {
            return [rowItem.HoDApproval !== true, "This note has already been approved."];
        }
    }, {
        "label": "HoA Approval",
        action: hoaApproveNote,
        show({ rowItem }) {
            
            return [rowItem.HOAApproval !== true, "This note has already been approved."];
        }
    }],
    "show": show
};

export { files, files2, testersFiles };

export const formfour = {
    "label": "Form Four Data",
    "key": "Form Four Data",
    "field": true,
    "fields": [{
        "label": "CV",
        "key": "FormFourFiles.CV",
        "actionButton": true,
        "actionText": "Download",
        async action({ pageItem, db }) {
            const url = await db.download(`people/${pageItem?.ID}/${pageItem?.FormFourFiles.CV}`);
            window.open(url, "_blank");
        },
        actionDisabled({ pageItem }) {
            return !(!!pageItem?.FormFourFiles?.CV);
        }
    }, {
        "label": "EASA",
        "key": "FormFourFiles.EASA",
        "actionButton": true,
        "actionText": "Download",
        async action({ pageItem, db }) {
            const url = await db.download(`people/${pageItem?.ID}/${pageItem?.FormFourFiles.EASA}`);
            window.open(url, "_blank");
        },
        actionDisabled({ pageItem }) {
            return !(!!pageItem?.FormFourFiles?.EASA);
        }
    }, {
        "label": "Sample Signature",
        "key": "FormFourFiles.SampleSignature",
        "actionButton": true,
        "actionText": "Download",
        async action({ pageItem, db }) {
            const url = await db.download(`people/${pageItem?.ID}/${pageItem?.FormFourFiles.SampleSignature}`);
            window.open(url, "_blank");
        },
        actionDisabled({ pageItem }) {
            return !(!!pageItem?.FormFourFiles?.SampleSignature);
        }
    }],
    "actions": [{
        "label": "Add CV",
        "action": addFormFourFile("CV")
    }, {
        "label": "Link a CV from an existing file",
        "action": linkFormFourFile("CV")
    }, {
        "label": "Add an EASA Post Holder document",
        "action": addFormFourFile("EASA"),
        "break": true
    }, {
        "label": "Link an EASA Post Holder document from an existing file",
        "action": linkFormFourFile("EASA")
    }, {
        "label": "Add a Sample Signature",
        "action": addFormFourFile("SampleSignature"),
        "break": true
    }, {
        "label": "Link a Sample Signature from an existing file",
        "action": linkFormFourFile("SampleSignature")
    }],
    show({ pageItem, store, meta }) {
        return Object.keys(pageItem?.ApprovedFunctions || {}).some(key => {
            let af = store.state["Matrices/SignatoryMatrix/ApprovedFunctions"][key];
            return af?.FormFourFunction || false;
        }) && show({ pageItem, store, meta })
    }
};

const cellClassRules = {
    "text-orange font-bold": params => {
        return params.data?.hasAnswered !== true;
    }
};

export const questions = {
    "label": "Application Questions",
    "key": "InterviewQuestions",
    // "local": true,
    "paginationPageSize": 50,
    "headers": [{
        "headerName": "Question",
        "field": "Question",
        "flex": 1,
        cellClassRules
    }, {
        "headerName": "Question Answered",
        "field": "hasAnswered",
        "type": "bool",
    }, {
        "headerName": "Points Awarded",
        "field": "Points",
        "type": "text",
        cellClassRules
    }],
    "fields": [{
        "label": "Role Point Threshold",
        compute({ pageItem, store }) {
            return get(store.state, `Matrices/SignatoryMatrix/ApprovedFunctions.${pageItem?.Role}.Threshold`, 0);
        },
        show({ pageItem }) {
            return !!pageItem?.Role
        }
    }, {
        "label": "Total Points Awarded",
        compute({ pageItem }) {
            return Object.values(pageItem?.InterviewQuestions || {}).reduce((acc, q) => {
                return acc + parseFloat(q.Points || 0);
            }, 0);
        }
    }],
    "actions": [],
    "rowActions": [{
        "label": "Review Answer",
        "action": ({ meta, ...rest }) => {
            const variant = resolveVariant(meta);
            return reviewAnswer(matrixRoot(variant))({ meta, ...rest });
        },

        show({ store, rowItem, meta }) {
            if (store?.state?.sigMatrixViewingNew !== true) {
                return [false, "Review is only available while viewing new submissions."];
            }

            const variant = resolveVariant(meta);
            const isMilitary = variant.key === "military";
            const isReviewer = isMilitary
                ? store?.state?.user?.Security?.Military?.Reviewer === true
                : store?.state?.user?.Security?.Matrices?.Reviewer === true;
            
            if (!isReviewer) {
                return [false, "You must be a reviewer to review this answer."];
            }

            if (rowItem?.hasAnswered !== true) {
                return [false, "This answer cannot be reviewed because it has not been answered yet."];
            }

            return [true, ""];
        }
    }, {
        "label": "Answer Question",
        "action": ({ meta, ...rest }) => {
            const variant = resolveVariant(meta);
            return answerQuestion(matrixRoot(variant))({ meta, ...rest });
        },
        show({ store, pageItem }) {
            return [pageItem?.AccountID === store.getters.userID, "Only the assigned User can answer this."]
        }
    }],
    show({ pageItem, store, meta }) {
        return show({ pageItem, store, meta }) && pageItem?.PointsExempt !== true;
    },
    computedData({ store, pageItem }) {
        let questions = store.state["Matrices/SignatoryMatrix/InterviewQuestions"];
        let approvedFunctions = [...(Object.keys(pageItem?.ApprovedFunctions || {}))];
        const qualifyingPanelAnswers = ["Compiler", "Checker", "Approver", "CVE"];

        return Object.values(questions || {}).filter(question => {
            const roleMatch = approvedFunctions.some(af => {

                return Object.keys(question.Roles || {}).includes(af);
            });
            const panelMatch = Object.keys(question.Panels || {}).some(pid => {
                const pa = (pageItem?.Panels || {})[pid];
                return pa && qualifyingPanelAnswers.includes(pa.Answer);
            });
            
            return roleMatch || panelMatch;
        }).map(i => {

            let answer = get(pageItem, `InterviewQuestions.${i.ID}`, {});
            
            
            return {
                "Question": i.Question,
                "ID": i.ID,
                "q": i,
                "a": answer,
                ...answer,
                "hasAnswered": Object.keys(answer).length > 0
            }
        });
    },
    warn({ items }) {
        // Check if all questions have been reviewed
        let hasUnreviewedQuestions = [!items.every(i => !!i.Points), "Not all questions have been reviewed."];

        // Check if all questions have been answered
        let hasUnansweredQuestions = [!items.every(i => i.hasAnswered === true), "Not all questions have been answered."];

        // Return the combined warning message if either condition is true
        return [hasUnreviewedQuestions[0] === true || hasUnansweredQuestions[0] === true,
        `
      ${hasUnansweredQuestions[0] === true ? `${hasUnansweredQuestions[1]}\n` : ''}
    `
        ];
    }
};

export const questions2 = {
    ...questions,
    computedData({ store, pageItem }) {
        let questions = store.state["Matrices/SignatoryMatrix/InterviewQuestions"];

        return Object.values(questions).filter(question => {

            return Object.keys(question.Roles || {}).includes(pageItem?.Role);

        }).map(i => {

            let answer = get(pageItem, `InterviewQuestions.${i.ID}`, {});
            return {
                "Question": i.Question,
                "ID": i.ID,
                "q": i,
                "a": answer,
                ...answer,
                "hasAnswered": Object.keys(answer).length > 0
            }
        });
    },
    "rowActions": [{
        "label": "Review Answer",
        "action": ({ meta, form, rowItem, pageItem, store, db }) => {
            const variant = resolveVariant(meta);
            const openFormsCollection = openFormsSignatories(variant);
            const question = store.state["Matrices/SignatoryMatrix/InterviewQuestions"][rowItem.ID];

            let fields = [];
            if (question.Answer) fields.push({
                "label": "Answer",
                "name": "Answer",
                "type": "value",
                value() {
                    return (rowItem.Answer == true || rowItem.Answer == "true") ? "Yes" : "No"
                }
            })
            if (question?.SupportingInformation) fields.push({
                "label": "Supporting Information",
                "name": "SupportingInformation",
                "type": "value",
                "grow": true,
                "divClass": "md:col-span-3",
                value() {
                    return rowItem.SupportingInformation
                }
            })
            
            form.setValues({ "Points": rowItem.Points || 0 })
            form.setConfig({
                "title": "Review Answer",
                "description": rowItem.Question,
                "type": "update",
                "location": `${openFormsCollection}/${pageItem.ID}/InterviewQuestions/${rowItem.ID}`,
                "fields": [...fields, {
                    "break": true,
                    "divClass": "md:col-span-3",
                }, {
                    "label": `Award Points (Max: ${question?.MaxPoints || 1})`,
                    "type": "number",
                    "name": "Points",
                    "step": "1",
                    "min": 0,
                    "max": question?.MaxPoints || 1
                }],
                preSubmitHook({ data }) {
                    return {
                        "Points": data.Points,
                        "Date": {
                            "Reviewed": (new Date()).toISOString()
                        },
                        "ReviewedBy": store.getters.userID,
                        "Answer": rowItem?.Answer || "",
                        "SupportingInformation": rowItem?.SupportingInformation || ""
                    }
                }
            });
            form.toggle();
        },
        show({ rowItem }) {
            return [rowItem.hasAnswered, "This question has not been answered"]
        }
    }, {
        "label": "Answer Question",
        "action": ({ meta, form, rowItem, pageItem, store, db }) => {
            const variant = resolveVariant(meta);
            const openFormsCollection = openFormsSignatories(variant);
            const question = store.state["Matrices/SignatoryMatrix/InterviewQuestions"][rowItem.ID];

            form.setValues(rowItem);
            
            let fields = [];
            if (question.Answer) fields.push({
                "label": "Answer",
                "name": "Answer",
                "type": "dropdown",
                "dropdownData": [{
                    "label": "Yes",
                    "id": true
                }, {
                    "label": "No",
                    "id": false
                }]
            })
            if (question.SupportingInformation) fields.push({
                "label": "Supporting Information",
                "name": "SupportingInformation",
                "type": "richtext",
                "divClass": "md:col-span-3"
            })

            form.setConfig({
                "title": "Answer Question",
                "description": rowItem.Question,
                "type": "update",
                "location": `${openFormsCollection}/${pageItem.ID}/InterviewQuestions/${rowItem.ID}`,
                "fields": fields
            });
            form.getDropdownData();
            form.toggle();
        },
        show({ store, pageItem }) {
            return [pageItem?.AccountID === store.getters.userID, "Only the assigned User can answer this."]
        }
    }]
};


export const records = {
    "label": "Training Records",
    "key": "TrainingRecords",
    "local": true,
    "headers": [{
        "headerName": "Date Start",
        "field": "Date.Start",
        "type": "date"
    }, {
        "headerName": "Date Complete",
        "field": "Date.Complete",
        "type": "date"
    }, {
        "headerName": "Training / Achievement / Experience",
        "field": "Training"
    }, {
        "headerName": "Outcomes / Comments",
        "field": "Outcomes"
    }, {
        "headerName": "Type",
        "field": "Type"
    }, {
        "headerName": "Approved By",
        "field": "ApprovedBy"
    }],
    "actions": [{
        "label": "Add Record",
        "action": addRecord
    }],
    "rowActions": [{
        "label": "Update Record",
        "action": updateRecord
    }, {
        "label": "Download Certificate",
        async action({ db, rowItem, router }) {
            let url = await db.download(`StaffTrainingRecords/${router.currentRoute.params.id}/${rowItem.ID}/${rowItem.Certificate}`);
            window.open(url, "__blank");
        },
        show({ rowItem }) {
            return [rowItem.Certificate, "Certificate not attached"];
        }
    }, {
        "label": "Remove Record",
        "action": removeRecord
    }],
    show({ store, pageItem }) {
        return (store?.state?.user?.Security?.General?.UserAdmin === true) || pageItem?.AccountID === store.getters.userID;
    
    }
};

// export const designChanges = {
//     "label": "Design Change's Responsible For",
//     "headers": [{
//         "headerName": "Number",
//         "field": "Number"
//     }, {
//         "headerName": "Title",
//         "field": "Title"
//     }, {
//         "headerName": "Mod Type",
//         "field": "Type"
//     }],
//     "rowActions": [{
//         "label": "View Design Change",
//         action({ router, rowItem }) {
//             router.push(`/Database/DesignChanges/${rowItem.ID}`)
//         }
//     }],
//     computedData({ store, pageItem }) {
//         if (!pageItem) return [];
//         return Object.values(store.state["Database/Refs/DesignChanges"] || {}).filter(i => {
//             return i.ResponsibleEngineer === `${pageItem.FirstName} ${pageItem.LastName}`;
//         });
//     }
// };


export const internalTraining = {

};

export const additionalRoles = {
    "label": "Additional Roles",
    "field": true,
    "fields": [{
        "label": "Roles",
        "class": "md:col-span-3",
        "grow": true,
        compute( { item }) {
            return item?.Roles || "None";
        }
    }],
    "actions": [{
        "label": "Update Additional Roles",
        "action": updateAdditionalRoles,
        show({ store, meta }) {
            const variant = resolveVariant(meta);
            const isMilitary = variant.key === "military";
            const isReviewer = isMilitary
                ? store?.state?.user?.Security?.Military?.Reviewer === true
                : store?.state?.user?.Security?.Matrices?.Reviewer === true;
            return [isReviewer, "You cannot update additional roles"];
        }
    }]
}

export const sampleSignature = {
    "label": "Sample Signature",
    "field": true,
    "actions": [{
        "label": "Upload Sample Signature",
        "action": addSampleSignature,
        show({ pageItem, store }) {
            return [store.getters.isUserAdmin, "This signatory has an account — upload the signature via their user profile."];
        }
    }],
    "fields": [{
        "label": "Sample Signature",
        "class": "md:col-span-3",
        "grow": true,
        "type": "image",
        async compute({ item, db }) {
            // Post-#117: key === ID === AccountID === auth.uid
            return loadSignatureImage(db, item?.ID || item?.AccountID);
        }
    }],
};
